<template>
  <!-- 法律服务面对面-律师团队 -->
  <div class="lawyer-team">
    <div class="titlebox">
      <h3 class="titleh3">{{type=='2'? params.region:'江苏省总'}}工会职工法律援助律师团队</h3>
      <!-- <a-dropdown v-if="type === '2'">
        <a-menu slot="overlay" @click="handleMenuClick">
          <a-menu-item
            :key="index"
            v-for="(item, index) in areaList.children"
            >{{ item.value }}</a-menu-item
          >
        </a-menu>
        <a-button style="margin-left: 8px">
          连云港市 <a-icon type="down" />
        </a-button>
      </a-dropdown> -->
      <a-select
        :default-value="defaultCityName"
        style="width: 120px"
        @change="handleChange"
        v-if="type === '2' || type === 2"
      >
        <a-select-option
          :value="item.value"
          v-for="item in areaList.children"
          :key="item.label"
        >
          {{ item.value }}
        </a-select-option>
      </a-select>
    </div>
    <ul class="team-list" v-if="lawyerList.length > 0">
      <li
        v-for="(item, index) in lawyerList"
        :key="index"
        @click="detailClick(item)"
      >
        <div class="whitebg">
          <div class="roleImg">
            <img
              v-if="item.photo_att_url != null"
              :src="BASEURL+'RESOURCE/' + item.photo_att_url"
              alt=""
            />
            <img v-else src="@/assets/images/default-head.jpg" alt="" />
          </div>
          <p class="name">{{ item.name }}</p>
          <p class="office">{{ item.law_office_name }}</p>
        </div>
      </li>
    </ul>
    <div class="nodata" v-else>
      <img src="@/assets/images/noData.png" alt="" />
      <p>暂无数据</p>
    </div>
    <div class="btn-box">
      <a-button
        type="primary"
        class="btn"
        @click="appointClick"
        :disabled="lawyerList.length == 0"
        >开始预约</a-button
      >
    </div>
  </div>
</template>
<script>
import {getLawyerList} from '@/api/lawyer.js';
import {Modal} from "ant-design-vue";

export default {
  name: 'Lawyer',
  data() {
    return {
      lawyerList: [],
      type: null,
      areaList: {
        label: '江苏省',
        value: '江苏省',
        children: [
          {
            label: '南京市',
            id:'3201',
            value: '南京市',
          },
          {
            label: '无锡市',
            id:'3202',
            value: '无锡市',
          },
          {
            label: '徐州市',
            id:'3203',
            value: '徐州市',
          },
          {
            label: '常州市',
            id:'3204',
            value: '常州市',
          },
          {
            label: '苏州市',
            id:'3205',
            value: '苏州市',
          },
          {
            label: '南通市',
            id:'3206',
            value: '南通市',
          },
          {
            label: '连云港市',
            id:'3207',
            value: '连云港市',
          },
          {
            label: '淮安市',
            id:'3208',
            value: '淮安市',
          },
          {
            label: '盐城市',
            id:'3209',
            value: '盐城市',
          },
          {
            label: '扬州市',
            id:'3210',
            value: '扬州市',
          },
          {
            label: '镇江市',
            id:'3211',
            value: '镇江市',
          },
          {
            label: '泰州市',
            id:'3212',
            value: '泰州市',
          },
          {
            label: '宿迁市',
            id:'3213',
            value: '宿迁市',
          },
        ],
        letter: 'j',
      },
      params: {
        region: '江苏省',
      },
      // 默认展示的市级
      defaultCityName:'',
    };
  },
  created() {
    if(this.$route.query){
      this.type = this.$route.query.type;
    }
    // localStorage.setItem("webid",3211)
    let defaultRegion = ''
    defaultRegion = localStorage.getItem("webid")
    switch (defaultRegion){
      case '32':
        this.defaultCityName = '江苏省';
        this.params.region = '江苏省';
        this.getLawyerList()
      case '3201':
        this.defaultCityName = '南京市';
        this.params.region = '南京市';
        this.getLawyerList()
        break;
      case '3202':
        this.defaultCityName = '无锡市';
        this.params.region = '无锡市';
        this.getLawyerList()
        break;
      case '3203':
        this.defaultCityName = '徐州市';
        this.params.region = '徐州市';
        this.getLawyerList()
        break;
      case '3204':
        this.defaultCityName = '常州市';
        this.params.region = '常州市';
        this.getLawyerList()
        break;
      case '3205':
        this.defaultCityName = '苏州市';
        this.params.region = '苏州市';
        this.getLawyerList()
        break;
      case '3206':
        this.defaultCityName = '南通市';
        this.params.region = '南通市';
        this.getLawyerList()
        break;
      case '3207':
        this.defaultCityName = '连云港市';
        this.params.region = '连云港市';
        this.getLawyerList()
        break;
      case '3208':
        this.defaultCityName = '淮安市';
        this.params.region = '淮安市';
        this.getLawyerList()
        break;
      case '3209':
        this.defaultCityName = '盐城市';
        this.params.region = '盐城市';
        this.getLawyerList()
        break;
      case '3210':
        this.defaultCityName = '扬州市';
        this.params.region = '扬州市';
        this.getLawyerList()
        break;
      case '3211':
        this.defaultCityName = '镇江市';
        this.params.region = '镇江市';
        this.getLawyerList()
        break;
      case '3212':
        this.defaultCityName = '泰州市';
        this.params.region = '泰州市';
        this.getLawyerList()
        break;
      case '3213':
        this.defaultCityName = '宿迁市';
        this.params.region = '宿迁市';
        this.getLawyerList()
        break;
      default:
        this.defaultCityName = '南京市'
        this.params.region = '南京市';
        this.getLawyerList()
    }
    this.$forceUpdate()
  },
  mounted() {


    //
    // if (this.$route.query) {
    //   this.type = this.$route.query.type;
    //   if (this.type === 2 || this.type === '2') {
    //     this.params.region = '南京市';
    //   }
    //   this.getLawyerList();
    // }
  },
  methods: {
    getLawyerList() {
      console.log(this.type);
      let params = ''
      if(this.type==1){
         params="江苏省"
      }else{
         params = this.params.region
      }
      console.log(this.params);
      getLawyerList({
        region:params,
        rows:999
      }).then((res) => {
       //这里 rows
        console.log(res.items)
        this.lawyerList = res.items;
      });
    },
    handleChange(value) {
      console.log(`selected ${value}`);
      this.params.region = value;
      this.getLawyerList();
    },
    appointClick() {
      Modal.confirm({
        title: '提示',
        content: (<div>
          <p style="text-align: center;">律师服务面对面申请须知：</p>
          <p style="text-indent: 2em;">该页面律师信息仅做展示，申请人申请律师服务面对面不可指定律师，由当日现场值班律师进行接待。</p>
        </div>),
        onOk: () => {
          this.$router.push('/LawyerAppoint/LAppoint');
        },
        onCancel() {
        }
      })
    },
    detailClick(item) {
      console.log(item);
      // this.$router.push({name:'LawyerDetail'});
      let routeUrl = this.$router.resolve({
        name: 'LawyerDetail',
        query: { id: item.pkid},
      });
      window.open(routeUrl.href, '_blank');
    },
  },
};
</script>
<style scoped>
/* 滚动槽 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-track {
  border-radius: 3px;
  background: rgba(0,0,0,0.06);
  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.08);
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: rgba(0,0,0,0.12);
  -webkit-box-shadow: inset 0 0 10px rgba(0,0,0,0.2);
}
.lawyer-team {
  padding: 20px;
}
.titlebox {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.titlebox .titleh3 {
  margin-bottom: 0;
}
.team-list {
  clear: both;
  /* overflow:hidden; */
  overflow:auto;
  margin-bottom: 0;
  height: 500px;
}
.team-list li {
  list-style: none;
  width: 188px;
  height: 325px;
  box-sizing: border-box;
  background: #f8fcff;
  border: 2px solid #eef8ff;
  text-align: center;
  padding: 6px;
  float: left;
  margin-right: 50px;
  margin-bottom: 35px;
  cursor: pointer;
}
.team-list li:nth-child(5n) {
  margin-right: 0;
}
.team-list .roleImg {
  width: 172px;
  height: 230px;
  margin: 0 auto;
}
.team-list .roleImg img {
  width: 100%;
  height: 100%;
  display: block;
}
.team-list p {
  line-height: 1;
  margin: 0;
}
.team-list p.name {
  margin: 18px 0 12px 0;
}
.team-list p.office {
  padding-bottom: 18px;
}
.whitebg {
  background: #fff;
}
.btn-box {
  text-align: center;
  padding-top: 1px;
}
.btn-box .btn {
  width: 200px;
  height: 52px;
  line-height: 52px;
  display: inline-block;
  text-align: center;
  background: #2b86ef;
  color: #fff;
  border-radius: 2px;
}
.nodata {
  text-align: center;
  margin: 120px 0;
  font-size: 18px;
  font-weight: bold;
}
.nodata img {
  width: 150px;
  margin-bottom: 20px;
}
</style>
